import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-rate-config',
  templateUrl: './d-rate-config.component.html',
  styles: []
})
export class DRateConfigComponent extends DynamicComponentBase {
  static KEY = 'd-rate-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
